import { SearchExport, SearchExportListPagination, StartSearchExportResponse } from '../../services/search-export.service';

export interface SearchExportState {
  startExport: {
    isLoading: boolean;
    result: StartSearchExportResponse | null;
    error: string | null;
  };
  exports: {
    items: SearchExport[];
    isLoading: boolean;
    error: string | null;
    pagination: SearchExportListPagination;
  };
  download: {
    downloadingIds: number[];
    error: string | null;
  };
}

export const initialSearchExportState: SearchExportState = {
  startExport: {
    isLoading: false,
    result: null,
    error: null
  },
  exports: {
    items: [],
    isLoading: false,
    error: null,
    pagination: {
      total: 0,
      per_page: 15,
      current_page: 1,
      last_page: 1
    }
  },
  download: {
    downloadingIds: [],
    error: null
  }
};
